import React from 'react';

import {FloatingPlacement, FloatingInteraction} from 'ui-library/floating-ui/FloatingConstants';
import Popover from 'ui-library/floating-ui/Popover';

import EnzymeActivityTableWithProviderSelector from './EnzymeActivityTableWithProviderSelector';
import {Provider} from './EnzymeConstants';

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  enzymes: Array<any>;
  provider: Provider;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChangeProvider: (...args: Array<any>) => any;
  providers: Array<Provider>;
}

export default function EnzymeActivityPopoverLink(props: Props): JSX.Element {
  return (
    <Popover
      renderContent={() => (
        <EnzymeActivityTableWithProviderSelector
          provider={props.provider}
          onChangeProvider={props.onChangeProvider}
          providers={props.providers}
          enzymes={props.enzymes}
          pullSelectorRight={true}
          small={true}
        />
      )}
      placement={FloatingPlacement.LEFT}
      interaction={FloatingInteraction.CLICK}
    >
      <a>View Enzyme Activity</a>
    </Popover>
  );
}
